import { IlogisticServiceDetails } from 'types/services';
import { displayErrorNotification } from 'utils/displayNudosStandardNotifications';

export const formatDataForLogisticServiceSummaryCard = (logisticServiceData?: IlogisticServiceDetails) => {
  try {
    return {
      userData: {
        firstName: logisticServiceData?.requester?.firstName!,
        lastName: logisticServiceData?.requester?.lastName!,
        phone: logisticServiceData?.requester?.phone!,
        phoneCode: logisticServiceData?.requester?.phoneCountry?.phoneCode!,
        email: logisticServiceData?.requester?.email!
      },
      orgData: {
        organizationId: logisticServiceData?.organization?.organizationId!,
        organizationName: logisticServiceData?.organization?.organizationName!,
        countryCode: logisticServiceData?.organization?.country?.code!,
        levelSubscription: logisticServiceData?.organization?.levelSubscription!
      }
    };
  } catch (error) {
    displayErrorNotification();
  }
};
